import type { ApplicationContext } from './shared-types'
import type {
  DataAlterationGuardRequest,
  ResetToDefaultVerdict,
} from '@app/shared/services/data-alteration-guard.types'

import { publishGuard } from '@app/shared/services/data-alteration-guard'

// The decider for the reset-to-default guard. A NextGen field asks it before it
// drops an override, so the user sees the modal a Liquid input shows.
export default (appContext: ApplicationContext): ApplicationContext => {
  publishGuard('reset-to-default')

  window.eventHub.$on(
    'data-alteration-guard-request',
    (request: DataAlterationGuardRequest) => {
      if (request.guard !== 'reset-to-default') return

      const answer = (verdict: ResetToDefaultVerdict): void => {
        window.eventHub.$emit('data-alteration-guard-result', {
          requestId: request.requestId,
          guard: 'reset-to-default',
          ...verdict,
        })
      }

      window.modalCitizen.openModal('restore-default-confirmation-modal', {
        defaultValue: request.defaultValue,
        isInput: request.isInput,
        saveCallback: () => answer({ confirmed: true }),
        cancelCallback: () => answer({ confirmed: false }),
      })
    }
  )

  return appContext
}
